import { Text } from "../../FormControls/Text";
import { Fragment } from "react";
import { Box } from "../../FormControls/Box";
import { Stack } from "../../FormControls/Stack";
import { ScreenControl } from "../ScreenControl";
import { Button } from '../../FormControls/Button';
import { useDispatch, useSelector } from "react-redux";
import { jump } from "../../../../main/slices/routerSlice";
import { CheckCircleOutlineRounded, InfoOutlined, ArrowBackIos } from "@mui/icons-material";

export const Success = ({ dimensions }) => {
  let info5b = [];
  let infoCash = [];
  const state = useSelector(({ transaction }) => transaction);
  const userState = useSelector(({ user }) => user);
  const currentDate = new Date();
  const dispatch = useDispatch();

  // Opciones para formatear la fecha
  const options = {
    weekday: "long", // Día de la semana completo (martes)
    day: "2-digit", // Día con dos dígitos (10)
    month: "long", // Nombre completo del mes (diciembre)
    year: "numeric", // Año (2024)
    timeZone: "GMT", // Asegura que sea en GMT
  };
  // Formatear la fecha
  const dateFormat = currentDate.toLocaleDateString("es-ES", options);

  info5b = [
    { label: "Fecha", value: dateFormat },
    { label: "Tipo", value: "Operaciones sin tarjeta" },
    { label: "Institución", value: "80" },
    { label: "DPI", value: userState.dpi.value },
    { label: "Código de Referencia", value: state.reference.value },
    {
      label: "Monto",
      value: `${parseFloat(state.total.value).toFixed(2)} Quetzales`,
    }, // CONTEMPLAR RESTO DE MONEDAS LUEGO
  ];

  const coupons = userState.paymentType.value === "COUPON";
  infoCash = [
    { label: "Fecha", value: dateFormat },
    { label: "Código de Referencia", value: state.reference.value },
    { label: "DPI", value: userState.dpi.value },
    {
      label: "Monto",
      value: `${parseFloat(state.total.value).toFixed(2)} Quetzales`,
    }, // CONTEMPLAR RESTO DE MONEDAS LUEGO
    {
      label: `Para realizar el canje${!coupons ? " por efectivo" : ""}, dirígete a cualquiera de nuestros puntos. Puedes ver los puntos`,
      value: (        
        <a
          href="https://coincaex.com/CentrosRetiroEfectivo"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "blue", textDecoration: "underline" }}
          onClick={(e) => {
            e.preventDefault(); // Evitar el comportamiento predeterminado del enlace
            window.open(
              "https://coincaex.com/CentrosRetiroEfectivo",
              "_blank",
              "noopener,noreferrer"
            );
          }}
        >
          aquí
        </a>
      ),
    },
  ];

  return (
    <Fragment>
      <div style={{ padding: "0 1.5rem" }}>
        {/* SCREEN LEGENDS */}
          <>
            <CheckCircleOutlineRounded
              sx={{ fontSize: "10em", margin: "0 0.5em", color: "#99b83c" }}
            />
            <Text
              classes={["title"]}
              style={{ alignItems: "center", textAlign: "center" }}
            >
              ¡Transacción Finalizada!
            </Text>

            {userState.paymentType.value === "FIAT:5B" && (
              <Stack flex={{ flexDirection: "Column", gap: 20 }}>
                <Text
                  classes={["subtitle"]}
                  style={{
                    fontWeight: "bold",
                    color: "#560eea",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  {
                    "Por favor, guarda estos datos tomando una captura de pantalla y no los compartas con nadie o podrías perder tus fondos."
                  }
                </Text>
                <Text>
                  {
                    "Su retiro ha sido procesado correctamente en cajeros 5B con los siguientes detalles:"
                  }
                </Text>
                <Text>
                  {info5b.map((detalle, index) => (
                    <Text key={index}>
                      <span style={{ fontWeight: "bold", color: "#323232" }}>
                        {`${detalle.label}: `}
                      </span>
                      {`${detalle.value}\n`}
                    </Text>
                  ))}
                </Text>
              </Stack>
            )}
          </>
      </div>
      <Button 
          style={{
              position: "fixed",
              top: "1.5rem",
          }} 
          classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
          onClick={() => dispatch(jump({ current: 8, direction: "backward" })) }
      >
          <ArrowBackIos />
      </Button>
      <div style={{ marginBottom: "2rem" }}></div>
      <ScreenControl 
        showGoBack= {false}
        disabled={false} index={{ fw: 8 }}
      ></ScreenControl>
    </Fragment>
  );
};
